export const bio = `Действующий веб-разработчик и опытный преподаватель. Обучаю созданию сайтов: от самых основ до профессий веб-мастера, верстальщика и frontend-разработчика - JavaScript, TypeScript, React, Redux и многое другое. В настоящий момент работаю в Испании.
`;
